import { render, staticRenderFns } from "./editSpec.vue?vue&type=template&id=852e8d28&scoped=true&"
import script from "./editSpec.vue?vue&type=script&lang=js&"
export * from "./editSpec.vue?vue&type=script&lang=js&"
import style0 from "./editSpec.vue?vue&type=style&index=0&id=852e8d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852e8d28",
  null
  
)

component.options.__file = "editSpec.vue"
export default component.exports